import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHourglass: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHourglass"><Path fillRule="evenodd" clipRule="evenodd" d="M5 8.53518V4H3V2H21V4H19V8.53518L13.8028 12L19 15.4648V20H21V22H3V20H5V15.4648L10.1972 12L5 8.53518ZM7 7V4H17V7H7ZM17 18V16.5352L12 13.2019L7 16.5352V18H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHourglass;
